export function buildProductIdentityQueryParams({
  nombre,
  idProducto,
  idMuestra,
} = {}) {
  const params = new URLSearchParams();
  if (nombre) params.set("nombre", nombre);
  if (idProducto != null && idProducto !== "") {
    params.set("idProducto", String(idProducto));
  }
  if (idMuestra != null && idMuestra !== "") {
    params.set("idMuestra", String(idMuestra));
  }
  return params;
}

export function buildProductIdentityQueryString(options = {}) {
  return buildProductIdentityQueryParams(options).toString();
}
